import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { TYPE_SUCCESS } from '../../constants/snackbar';

import { gqlRequest } from '../../helpers/request';
import { getUser } from '../../helpers/user';
import * as commonSelectors from '../selectors/common';
import { cancelFavoritesUpdatingAction, deleteFavoritesAction, setFavoritesAction } from '../slices/common';
import { notifyAction } from '../slices/snackbar';
import { makeTranslate } from '@/modules/common/helpers/i18n';
import * as i18nSelectors from '@/modules/common/redux/selectors/i18n';

const queryGQL = `
  mutation hostedWatchDeleteFavorites(
    $mediaid: String,
  ) {
    hostedWatchDeleteFavorites(
      mediaid: $mediaid,
    )
  }
`;

export default (action$, state$) =>
  action$.pipe(
    ofType(deleteFavoritesAction.type),
    mergeMap(({ payload }) => {
      const t = makeTranslate(i18nSelectors.translationsSelector(state$.value));

      return gqlRequest({
        query: queryGQL,
        variables: {
          mediaid: payload,
        },
      }).pipe(
        mergeMap(({ errors }) => {
          const actions = [];
          if (!errors.length) {
            const favoritesVideo = commonSelectors.favoritesVideoSelector(state$.value).slice();
            const updatedFavorites = favoritesVideo.filter((mediaid) => mediaid !== payload);

            actions.push(of(setFavoritesAction(updatedFavorites)));

            const { accountId } = getUser();
            if (accountId) {
              actions.push(of(notifyAction({ variant: TYPE_SUCCESS, message: t.videoRemovedFromFavorites.text() })));
            }
          } else {
            actions.push(of(cancelFavoritesUpdatingAction()));
          }

          return concat(...actions);
        }),
      );
    }),
  );
